import { render, staticRenderFns } from "./editor_textChapter.vue?vue&type=template&id=45e2bc8a"
import script from "./editor_textChapter.vue?vue&type=script&lang=js"
export * from "./editor_textChapter.vue?vue&type=script&lang=js"
import style0 from "./editor_textChapter.vue?vue&type=style&index=0&id=45e2bc8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports